import { useContext, useState } from "react"
import { Div, Text } from "atomize"
import { toast } from "react-toastify"
import { faUserMinus } from "@fortawesome/free-solid-svg-icons"
import ConfirmButtons from "../buttons/ConfirmButtons"
import Container from "../atoms/Container"
import { theme } from "../settings/config"
import { callFunction } from "../services/firebase.service"
import { schoolContext } from "../providers/school.provider"

// Togliere un collega dal circolo è il gesto che gli chiude l'accesso: da
// quel momento le regole non gli fanno più leggere gli allievi di qui. Le
// lezioni che ha segnato restano dove sono — sono successe davvero.
export function RevokeColleagueModal({ closeModal, colleague }) {
	const { selectedSchool, getSelectedSchool } = useContext(schoolContext)
	const [isSaving, setIsSaving] = useState(false)

	const name = colleague?.coachName ?? colleague?.coachID
	const isPending = !colleague?.firebaseUID

	const handleRevoke = async () => {
		setIsSaving(true)
		try {
			const revokeColleague = callFunction("revokeColleague")
			await revokeColleague({ schoolID: selectedSchool, coachID: colleague.coachID })
			toast.success(isPending ? "Invito annullato" : `${name} non è più nel circolo`, {
				position: "top-center",
			})
			closeModal()
		} catch (err) {
			toast.error(err.message || "Non sono riuscito a toglierlo", {
				position: "top-center",
			})
		} finally {
			setIsSaving(false)
		}
	}

	return (
		<Container>
			<Div m={{ b: "0.5rem" }} textWeight="bold" textSize="title">
				{isPending ? `Annullare l'invito di ${name}?` : `Togliere ${name} dal circolo?`}
			</Div>
			<Text textColor={theme.colors.gunmetal}>
				{isPending
					? "Non è mai entrato, quindi sparisce del tutto: il codice che gli hai dato smette di funzionare."
					: `Da subito non vedrà più gli allievi né le lezioni di ${
							getSelectedSchool()?.schoolName
						}. Le lezioni che ha segnato restano dove sono, e se lavora anche altrove quel posto non lo perde.`}
			</Text>
			<ConfirmButtons
				confirmText={isPending ? "Sì, annullalo" : "Sì, toglilo"}
				icon={isPending ? undefined : faUserMinus}
				busy={isSaving}
				busyText={isPending ? "Lo annullo..." : "Lo tolgo..."}
				onConfirm={handleRevoke}
				onCancel={closeModal}
			/>
		</Container>
	)
}

export default RevokeColleagueModal
